// both test variants use the same strings
export const STRING_CELEBRATION_TITLE = 'Finally, an easier way to find work.';
export const STRING_CELEBRATION_CONTINUE = 'Continue';
export const STRING_CELEBRATION_ONE_CLICK_TITLE = 'Apply With One Click';
export const STRING_CELEBRATION_ONE_CLICK_DESCRIPTION = 'We help you save time by making it easy to apply jobs with one click.';
export const STRING_CELEBRATION_INVITE_APPLY_TITLE = 'Let Employers Apply to You';
export const STRING_CELEBRATION_INVITE_APPLY_DESCRIPTION = 'We show your profile to employers that are a fit so they can invite you to apply.';
export const STRING_CELEBRATION_GREAT_MATCH_TITLE = 'Know You’re a Great Match';
export const STRING_CELEBRATION_GREAT_MATCH_DESCRIPTION = 'We tell you if you’re a strong candidate so you can prioritize where to apply.';
export const STRING_CELEBRATION_ZIPRECRUITER = 'ZipRecruiter';
export const STRING_PHIL_TITLE = 'Hi, I’m Phil, your AI personal recruiter.';

export const SECOND_TIME_STRING_CELEBRATION_TITLE = 'Great job! I’ll take it from here.';
export const SECOND_TIME_CELEBRATION_DESCRIPTION_TEXT = 'We’re going to make an amazing team. Now that I’ve got your profile, your job search just got a lot easier! Check out a few of the cool things you can enjoy.';
export const SECOND_TIME_CONTINUE_BUTTON_TEXT = "Let's do this!";
